// src/pages/FullProduct.jsx
import React, { useEffect } from "react";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/Footer";
import ProductHero from "./ProductHero/ProductHero";
import Product from "./FullProduct/FullProduct";

const FullProduct = () => {
    // Ensure the page starts at the top when loaded
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="full-about-page fade-in">
      <Navbar />
     <ProductHero/>
     <Product/>
     
      <Footer />
    </div>
  );
};

export default FullProduct;
